<template>
    
</template>
<script>
export default {
  props: {
    role: String,
    name: String,
  }
};
</script>

<style scoped>

</style>